// Fallback.jsx
import React, { ErrorInfo } from 'react';
import { getCookie } from '@utiljs/cookie';
import Button from '@roo/roo/Button';
import './fallback.scss';

const userInfo = {
    cityid: getCookie('cityId'),
    acctId: getCookie('acctId'),
    wmPoiId: getCookie('wmPoiId'),
    uuid: getCookie('device_uuid'),
};

export interface IFallbackProps {
    error: Error | null;
    errorInfo: ErrorInfo | null;
    timestamp: number | null;
}

const Fallback: React.FunctionComponent<IFallbackProps> = (props: IFallbackProps) => {
    const { timestamp } = props;
    return (
        <div className="default-fallback">
            <div className="empty-img-wrap" />
            <p>界面展示异常，请稍后重试。</p>
            <p>
                <Button
                    onClick={() => {
                        window.top.location.href = '/';
                    }}
                >
                    回首页
                </Button>
                <Button
                    style={{ marginLeft: 20 }}
                    onClick={() => {
                        window.location.reload();
                    }}
                >
                    刷新页面
                </Button>
            </p>
            <p className="unique-code">{`${userInfo.uuid}|${timestamp}`}</p>
        </div>
    );
};

export default Fallback;
